import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { commonQuoteAction } from 'state/forms/actions/quote';
import type { EpicWithThunk } from 'state/state.common';

export function removeStaticQuote(): EpicWithThunk {
  return (action$, state$, { selectors: { getStaticFormInfos, getFormWorkflowStatus } }) => {
    const formInputChangeTabId$ = action$.pipe(
      ofType('FORM_INPUT_DATA_CHANGED'),
      map(action => action.tabId),
    );

    const formEnrichmentRequested$ = action$.pipe(
      ofType('FORM_ENRICHMENT_REQUESTED'),
      map(action => action.tabId),
    );

    const productCodesRequested$ = action$.pipe(
      ofType('PRODUCT_CODES_REQUESTED'),
      filter(action => action.workspace === 'static'),
      map(action => action.tabId),
    );

    return merge(formInputChangeTabId$, formEnrichmentRequested$, productCodesRequested$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const formWorkflowStatus = getFormWorkflowStatus(state, 'static', tabId);
        const shouldResetSidePanel = formWorkflowStatus === 'REJECTED';
        const quoteId = getStaticFormInfos(state, tabId)?.quoteId;

        if (shouldResetSidePanel) {
          return of(commonQuoteAction.quoteRemoved('static', tabId, quoteId));
        }

        return quoteId !== undefined ? of(commonQuoteAction.quoteStale('static', tabId, quoteId, true)) : EMPTY;
      }),
    );
  };
}
